export default class ServiceContainer {
    constructor() {
        this.services = {};
    }
    setService(name, service) {
        this.services[name] = service;
    }
    getService(name) {
        return this.hasService(name) ? this.services[name] : null;
    }
    hasService(name) {
        return this.services.hasOwnProperty(name);
    }
}
